import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { HiOutlineMapPin } from "react-icons/hi2";
import { IoMailOutline } from "react-icons/io5";
import { FiPhone } from "react-icons/fi";
import { SlSocialInstagram, SlSocialFacebook, SlSocialLinkedin, SlSocialYoutube } from "react-icons/sl";
import { PiTiktokLogo } from "react-icons/pi";
import Link from 'next/link';

export default function Footer() {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <footer className="bg-main pt-[90px] lg:pt-[100px] pb-[70px]">
      <div className="max-w-[98%] lg:max-w-[90%] mx-auto px-[15px] md:px-4 lg:px-0">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-[40px] gap-[24px]">
          <div className="text-left flex w-full lg:max-w-[70%]">
            <h2 
              className="text-[20px] lg:text-[40px] font-bold text-white leading-tight w-full"
              dangerouslySetInnerHTML={{ __html: t('footer-title') }}
            />
          </div>

          <div className="flex items-center space-x-4">
            <a href="https://www.instagram.com/peerstack.tech" target="_blank" rel="noopener noreferrer" className="w-[38px] h-[38px] rounded-full flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity bg-white/20" aria-label="Instagram">
              <SlSocialInstagram className="text-white text-[20px]" />
            </a>
            <a href="https://www.facebook.com/peerstack.tech" target="_blank" rel="noopener noreferrer" className="w-[38px] h-[38px] rounded-full flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity bg-white/20" aria-label="Facebook">
              <SlSocialFacebook className="text-white text-[20px]" />
            </a>
            <a href="https://www.linkedin.com/company/peerstack-academy/" target="_blank" rel="noopener noreferrer" className="w-[38px] h-[38px] rounded-full flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity bg-white/20" aria-label="LinkedIn">
              <SlSocialLinkedin className="text-white text-[20px]" />
            </a>
            <a href="https://www.tiktok.com/@peerstack.academy" target="_blank" rel="noopener noreferrer" className="w-[38px] h-[38px] rounded-full flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity bg-white/20" aria-label="TikTok">
              <PiTiktokLogo className="text-white text-[20px]" />
            </a>
            <a href="https://www.youtube.com/@PeerstackAcademy" target="_blank" rel="noopener noreferrer" className="w-[38px] h-[38px] rounded-full flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity bg-white/20" aria-label="YouTube">
              <SlSocialYoutube className="text-white text-[20px]" />
            </a>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-[40px] lg:mb-[100px] flex-wrap gap-[20px]">
          <div className="flex flex-col lg:flex-row items-start lg:items-center max-w-full lg:max-w-[70%] gap-[24px]">
            <div className="flex items-center space-x-3">
              <div className="min-w-[46px] min-h-[46px] bg-white rounded-full flex items-center justify-center border-2 border-main">
                <HiOutlineMapPin className="text-[#1053F3] text-[24px]" />
              </div>
              <span className="text-white text-[14px]">{t('address')}</span>
            </div>

            <div className="flex items-center space-x-3 min-w-[200px]">
              <div className="min-w-[46px] min-h-[46px] bg-white rounded-full flex items-center justify-center border-2 border-main">
                <IoMailOutline className="text-[#1053F3] text-[24px]" />
              </div>
              <Link href="mailto:info@peerstack.tech" className="text-white text-[14px] hover:underline focus:outline-none focus:underline underline-offset-4">info@peerstack.tech</Link>
            </div>

            <div className="flex items-center space-x-3 min-w-[200px]">
              <div className="min-w-[46px] min-h-[46px] bg-white rounded-full flex items-center justify-center border-2 border-main">
                <FiPhone className="text-[#1053F3] text-[24px]" />
              </div>
              <Link href="tel:+994552508887" className="text-white text-[14px] hover:underline focus:outline-none focus:underline underline-offset-4">+99455 250 88 87</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-[20px] lg:pt-[40px]">
          <div className="flex flex-col sm:flex-row justify-between gap-[20px]">
            <div className="flex items-center gap-[20px]">
              <p className="text-[16px] text-white">© Peerstack Academy</p>
            </div>
            <div className='flex gap-[20px] justify-between flex-col xs:flex-row'>
              <Link href="/terms-of-conditions" className="text-white text-[16px]">{t('terms-of-conditions')}</Link>
              <Link href="/privacy-policy" className="text-white text-[16px]">{t('privacy-policy')}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
